import React from 'react';
import { useParams } from "react-router-dom";

const OrderConfirmationPage = () => {
    const { orderId } = useParams();

    return (
        <div className="container mt-4 mt-lg-5" style={{ maxWidth: "700px" }}> 
            <h6>✅ Your car has been successfully submitted!</h6>
        
            <strong>Your Order ID: is</strong><code>{orderId}</code><br /> 
        
            {/*
            <p className="lead">Please complete your payment to activate the listing.</p>
            <h5 className="mt-4">💳 Payment Options:</h5>
            <ul>
                <li><strong>Normal Post</strong> – ETB 500</li>
                <li><strong>Featured Post</strong> – ETB 1,000</li>
                <li><strong>Premium Post</strong> – ETB 1,300</li>
            </ul>
        
            <h6 className="mt-4">💼 Bank & Payment Details:</h6>
            <p>
                <strong>Commercial Bank of Ethiopia (CBE)</strong><br />
                Account Name: EthiocarHub<br />
                Account Number: <code>1000123456789</code>
            </p>
            <p>
                <strong>Awash Bank</strong><br />
                <strong>Account Name:</strong> EthiocaraHub<br />
                <strong>Account Number:</strong> <code>01234567890123</code>
            </p>
            <p>
                <strong>Hijra Bank</strong><br />
                Account Name: EthiocarHub<br />
                Account Number: <code>3000123456789</code>
            </p>
            <p>
                <strong>Telebirr</strong><br />
                Account Name: EthiocarHub<br />
                Phone Number: <code>+251911000000</code>
            </p>

            <h6 className="mt-4">📤 After Payment:</h6>
            <p>
                Please send your payment proof (screenshot or transaction code) along with your <strong>Order ID</strong> via:
            </p>
            <ul>
                <li>📱 <strong>Telegram:</strong> <a href="https://t.me/ethiocarhub" target="_blank" rel="noopener noreferrer">@mekinahub</a></li>
                <li>📞 <strong>WhatsApp:</strong> <a href="https://wa.me/251900000000" target="_blank" rel="noopener noreferrer">+251 900 000 000</a></li>
            </ul>

            <div className="alert alert-info mt-4">
                <strong>Your Order ID:</strong> <code>{orderId}</code><br />
                <small>📌 Please include this Order ID in your payment message.</small>
            </div>

            <p>
                Go to:{" "}
                <a href={`https://ethiocarhub.com/order/${orderId}`} target="_blank" rel="noopener noreferrer">
                    ethiocarhub.com/order/{orderId}
                </a>
            </p>
            */}
        </div>
    );
};

export default OrderConfirmationPage;


